import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-live"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fehlerText)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["gevng-form-validation__error-container", {
      'gevng-form-validation__error-container-reduziert': _ctx.reduzierterAbstand,
    }]),
        role: "alert",
        "aria-label": "Fehlerhafte Eingabe",
        "aria-live": _ctx.fehlerText ? 'assertive' : 'off'
      }, _toDisplayString(_ctx.fehlerText), 11, _hoisted_1))
    : _createCommentVNode("", true)
}